'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Root-layout error boundary TEMPLATE for the OwlCat fleet.
 *
 * Re-export as the default from `app/global-error.tsx`:
 *
 *   export { GlobalError as default } from '@owlcat/ui';
 *
 * Catches crashes that route-level `error.tsx` files cannot (errors thrown by
 * the root layout itself), so it must render its OWN <html>/<body>. It is
 * rendered OUTSIDE the theme/token providers, so it uses inline system styles
 * (no design tokens available here). Server-side detail lands in the structured
 * log via `instrumentation.onRequestError` (@owlcat/observability); the digest
 * links this screen to that log line.
 */
export function GlobalError({ error, reset, }) {
    return (_jsx("html", { lang: "en", children: _jsx("body", { style: { fontFamily: 'system-ui, sans-serif' }, children: _jsx("div", { style: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }, children: _jsxs("div", { style: { maxWidth: 420, textAlign: 'center' }, children: [_jsx("div", { style: { fontSize: 48 }, children: "\u26A0\uFE0F" }), _jsx("h2", { style: { margin: '16px 0' }, children: "Something went wrong" }), error?.digest && (_jsxs("p", { style: { color: '#888', fontSize: 12 }, children: ["Error ID: ", error.digest] })), _jsx("button", { type: "button", onClick: reset, style: { marginTop: 16, padding: '8px 24px', borderRadius: 8, border: '1px solid #ccc', cursor: 'pointer' }, children: "Try again" })] }) }) }) }));
}
